<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-primary pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-12 col-md-12">
              <h1 class="display-3 text-white">Ausencias Programadas</h1>
              <p
                class="text-white mt-0"
              >La búsqueda comprende registros dentro de los últimos 60 días a partir de la fecha actual.</p>
              <p>
                <button class="btn btn-success" type="button" @click="showModal">
                  <i class="fa fa-clock-o"></i> Programar ausencia
                </button>
              </p>
              <div class="row mt-5">
                <div class="col-lg-3 col-sm-6 col-xs-12 mb-1">
                  <div class="form-group text-white search-input">
                    <label for="input-campaign">Buscar usuario</label>
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fas fa-search"></i>
                        </span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Buscar por nombre o email"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">
            <div class="col-sm-12">
              <div class="card shadow">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="bg-secondary">
                      <tr>
                        <th>Fechas</th>
                        <th>Detalles</th>
                        <th>Creado</th>
                        <th>Estado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ausencias" :key="'keyItemTable_'+index+item.id">
                        <td>
                          <strong>Desde:</strong>
                          {{ item.desde | formatDate }}
                          <br />
                          <strong>Hasta:</strong>
                          {{item.hasta | formatDate }}
                        </td>
                        <td>
                          <small class="text-muted">
                            <strong>Motivo:</strong>
                            {{item.motivo}}
                          </small>
                          <br />
                          {{ item.descripcion }}
                        </td>
                        <td>{{ item.createdAt | formatDate }}</td>
                        <td>
                          <span
                            class="badge badge-pill badge-success"
                            :class="checkIfDeprecated(item.hasta) ? 'badge-danger':'badge-success'"
                            v-text="checkIfDeprecated(item.hasta) ? 'Vencido':'Pendiente'"
                          ></span>
                        </td>
                        <td class="text-right">
                          <button
                            v-if="!checkIfDeprecated(item.hasta)"
                            class="btn btn-secondary btn-sm"
                            @click="selectItem(item)"
                          >Editar</button>
                          <button class="btn btn-secondary btn-sm text-danger">Eliminar</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <h2>Fechas Programadas</h2>
          <hr />
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div
          class="col-sm-4 mb-3"
          v-for="(item, index) in pendingDates()"
          :key="'keyItemFigure_'+index+item.id"
        >
          <div class="form-group mb-2 --datepicker --hiden-input">
            <flat-pickr
              :value="item.desde+' a '+item.hasta"
              :config="config2"
              class="form-control"
              placeholder
              name="date"
            ></flat-pickr>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="my-modal" hide-footer hide-header no-close-on-backdrop>
      <div class="card card-body shadow">
        <div class="mb-2">Seleccione un rango de fechas</div>
        <div class="form-group input-group mb-2 --datepicker">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="ni ni-calendar-grid-58"></i>
            </span>
          </div>
          <flat-pickr
            v-model="range"
            :config="config"
            class="form-control"
            placeholder="Seleccciona un rango de fechas"
            name="date"
          ></flat-pickr>
        </div>
        <div class="form-group mb-2">
          <select name id class="form-control" v-model="ausencia.motivo" :disabled="!fechaVigente">
            <option value="0">Seleccione un motivo</option>
            <option value="Licencia Médica">Licencia Médica</option>
            <option value="Día administrativo">Día administrativo</option>
            <option value="Otro">Otro</option>
          </select>
        </div>
        <div class="form-group mb-2">
          <textarea
            :disabled="!fechaVigente"
            class="form-control"
            placeholder="Indique una descripción breve"
            maxlength="300"
            v-model="ausencia.descripcion"
            id
            rows="2"
          ></textarea>
        </div>
        <div class="form-group mb-2" v-if="!fechaVigente">
          <div
            class="alert p-2 text-danger text-center"
          >Este registro ha caducado y no puede modificarse.</div>
        </div>
        <div class="form-group mb-2 text-right">
          <button type="button" class="btn btn-link" @click="hideModal">Cancelar</button>
          <button type="button" class="btn btn-success" v-if="fechaVigente" @click="addAusencia">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import sysMsg from "@/helpers/system.message";
import { Spanish } from "flatpickr/dist/l10n/es.js";

const initialState = {
  id: 0,
  rango: "",
  motivo: 0,
  descripcion: "",
  desde: "",
  hasta: moment().format("YYYY-MM-DD"),
  createdAt: moment().format()
};

export default {
  name: "ausencias",
  name: "yourComponent",
  data() {
    return {
      controller: {
        title: "Ausencias",
        mainRouter: "/tinforamcion/ausencias"
      },
      vigentes: [],
      range: null,
      config: {
        wrap: false, // set wrap to true only when using 'input-group'
        altFormat: "M	j, Y",
        mode: "range",
        minDate: "today",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: Spanish // locale for this instance only
      },
      config2: {
        inline: true,
        mode: "range",
        locale: Spanish // locale for this instance only
      },
      ausencia: initialState,
      ausencias: [
        {
          createdAt: "2019-07-16T11:43:27-04:00",
          descripcion: "Cumpleaños",
          desde: "2019-07-17",
          hasta: "2019-07-17",
          id: "_4151563896607417",
          motivo: "Día administrativo"
        },
        {
          createdAt: "2019-07-23T11:43:27-04:00",
          descripcion: "Accidente laboral",
          desde: "2019-07-23",
          hasta: "2019-07-31",
          id: "_4151563896607418",
          motivo: "Licencia Médica"
        },
        {
          createdAt: "2019-07-23T11:43:27-04:00",
          descripcion: "Graduación hija menor.",
          desde: "2019-08-21",
          hasta: "2019-08-23",
          id: "_4151563896607419",
          motivo: "Otro"
        }
      ]
    };
  },
  computed: {
    fechaVigente() {
      return this.ausencia.hasta >= moment().format("YYYY-MM-DD");
    }
  },
  filters: {
    formatDate(val) {
      return moment(val).format("YYYY/MM/DD");
    }
  },
  created() {},
  methods: {
    addAusencia() {
      if (this.ausencia.id == 0) {
        let id = {
          id:
            "_" +
            new Date().getUTCMilliseconds().toString() +
            new Date().getTime().toString()
        };
        let ausencia = {
          ...id,
          ...this.ausencia,
          ...this.formatRange(this.range)
        };
        this.ausencias.push(ausencia);
        this.ausencia = initialState;
        sysMsg.getMessage("Registro guardada con éxito", "success");
        return;
      }

      let ausencias = this.ausencias;
      let index = this.ausencias.indexOf(this.ausencia);
      ausencias[index] = this.ausencia;
      this.ausencias = ausencias;

      sysMsg.getMessage("Registro actualizado con éxito", "info");
    },
    formatRange(str) {
      return {
        desde: str.substr(0, 10),
        hasta: str.substr(str.length - 10, str.length)
      };
    },
    selectItem(item) {
      this.range = `${item.desde} a ${item.hasta}`;
      this.ausencia = { ...item };
      this.showModal();
    },
    pendingDates() {
      let items = this.ausencias.filter(
        item => new Date(item.hasta) > new Date()
      );
      return items;
    },
    checkIfDeprecated(date) {
      return date < moment().format("YYYY-MM-DD");
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      this.range = null;
      this.ausencia = initialState;
    }
  }
};
</script>
<style lang="scss">
.--datepicker .form-control:disabled,
.--datepicker .form-control[readonly] {
  background-color: #fff !important;
  background: #fff;
}

.--datepicker {
  &.--hiden-input {
    pointer-events: none;
    .form-control {
      display: none !important;
    }
  }
}
.list-ausencia {
  .list-group-item {
    cursor: pointer;
    &:hover,
    &:focus {
      background: #f9f9f9;
    }
  }
}
</style>
